// エラーページ

/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
/*-------------------
    classのimport
---------------------*/
import Footer from '../components/Footer';

// クラス名
class ErrorPage extends Component {
  constructor(props) {
    super(props);

    document.title = `エラー`;

    // URLに設定されたものがあれば取得する。
    const urlQuery = new URLSearchParams(props.location.search);
    const kind = urlQuery.get('kind') || '10';

    this.state = { kind };
  }

  componentDidMount = async () => {};

  render() {
    const { kind } = this.state;

    return (
      <div id="container">
        {kind === '10' ? (
          <div className="errPage">
            <div>404</div>
            <div>Not Found</div>
            <div>ページが見つかりませんでした。</div>
          </div>
        ) : null}
        {kind === '20' ? (
          <div className="errPage">
            <div>501</div>
            <div>Not Implemented</div>
            <div>アクセスページは表示できませんでした。</div>
          </div>
        ) : null}
        {kind === '30' ? (
          <div className="errPage">
            <div>503</div>
            <div>Service Unavaliable</div>
            <div>アクセスページは表示できませんでした。</div>
          </div>
        ) : null}
        <Footer />
      </div>
    );
  }
}

ErrorPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(ErrorPage);
